"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";

/**
 * Engine-backed Hindi vrat date table (rule 23/24). Generic over the shared
 * FestivalSummary shape (ekadashi / amavasya / purnima / pradosh / sankashti),
 * so every Hindi vrat twin renders the SAME date component — no per-vrat copy to
 * drift. EVERY date here is the value the backend astrology engine returned for
 * that tithi; no date is hand-typed in this component or on any page. The "अगली"
 * (next) highlight is derived by comparing engine dates to today's IST date.
 */
export interface HiVratEntry {
  id: string;
  name_en: string;
  name_hi: string;
  date: string;
  month_hi: string;
}

export interface HiVratYearData {
  year: number;
  entries: HiVratEntry[];
}

export default function HiVratDates({
  years,
  vratLabelHi,
}: {
  years: HiVratYearData[];
  vratLabelHi: string;
}) {
  return (
    <EngineDateTable
      years={years}
      tabLabel={vratLabelHi}
      yearLabel="वर्ष"
      itemHeader={vratLabelHi}
      dateHeader="तिथि"
      detailHeader="हिंदू मास"
      emptyMessage={`${vratLabelHi} की तिथियाँ वैदिक इंजन से तुरंत गणना की जाती हैं। अभी सूची लोड नहीं हो सकी — कृपया एक क्षण में पुनः लोड करें ताकि हर तिथि अपने हिंदू मास के साथ दिखे।`}
      footer="सभी तिथियाँ Swiss Ephemeris की वास्तविक ग्रह गणना (लाहिरी अयनांश) से निकाली गई हैं — तिथि की वास्तविक संधि, कोई निश्चित कैलेंडर नहीं।"
      itemName={(entry) => entry.name_hi || entry.name_en}
      dateLocale="hi"
      nextLabel="अगली"
    />
  );
}
